// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import $ from 'jquery'
window.$ = $
window.jQuery = $

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const menus = {
  product: `
    <div class="main-links-section">
      <div class="subtitle">商品管理</div>
      <ul>
        <li class="pushy-link"><a href="/dashboard/products">所有商品</a></li>
        <li class="pushy-link"><a href="/dashboard/product_materials">材質管理</a></li>
        <li class="pushy-link"><a href="/dashboard/special_addons">特殊加工</a></li>
      </ul>
    </div>
  `,
  design: `
    <div class="main-links-section">
      <div class="subtitle">模板管理</div>
      <ul>
        <li class="pushy-link"><a href="/dashboard/design_files">所有模板</a></li>
        <li class="pushy-link"><a href="/dashboard/await_design_files">待審核模板</a></li>
      </ul>
    </div>
  `,
  material: `
    <div class="main-links-section">
      <div class="subtitle">貼圖管理</div>
      <ul>
        <li class="pushy-link"><a href="/dashboard/materials">所有貼圖</a></li>
        <li class="pushy-link"><a href="/dashboard/material_categories">貼圖分類</a></li>
      </ul>
    </div>
  `
};

$(function() {
  $('.product-btn').click(function(){
    $('#pushy-content').html(menus.product);
    $('body').addClass('pushy-open-left');
  });
  $('.design-file-btn').click(function(){
    $('#pushy-content').html(menus.design);
    $('body').addClass('pushy-open-left');
  });
  $('.material-btn').click(function(){
    $('#pushy-content').html(menus.material);
    $('body').addClass('pushy-open-left');
  });
  $(document).on('click', '.toggle-button', function(){
    $('body').removeClass('pushy-open-left');
  });
});
